<div class="flight-sector-container" #container>
  <div class="route" #bodycontainer>
    <div *ngFor="let sector of airValidationSector; index as i">
      <span *ngIf="isMobile; else desktopRoute">
        <p class="type">{{flightType(sector)}}</p>
        <p class="date">{{flightDepartureDate(sector) | date:'EEEE, d MMM yyyy'|  dateFormat }}</p>
        <p class="trip">{{flightTrip(sector)}}</p>
      </span>
      <ng-template #desktopRoute>
        <div class="collapsed-info-container">
          <div class="header" (click)="toggleTravelInfo(sector)">
            <span> {{flightType(sector) | transloco}}</span>
            <i aria-hidden="true" class="icon-arrow-drop-up rotate-90"></i>
            <span class="date">{{ flightDepartureDate(sector) | date: 'EEEE, dd MMMM' | dateFormat }}</span>
            <i aria-hidden="true" class="icon-arrow-drop-up right expander" [class.rotate-180]="!sector.isExpanded"> </i>
          </div>
          <ng-container *ngIf="!sector.isExpanded">
            <app-resume-sector
              [summaryProvider]="flightInfoProvider"
              [sector]="sector"
              [isInternational]="isInternational">
            </app-resume-sector>
          </ng-container>
        </div>
      </ng-template>
      <ng-container *ngIf="sector.isExpanded || isMobile">
        <div class="flight-sector-info">
          <ng-container *ngFor="let flight of sector.Flights; index as i">
            <app-travel-info
              [isMobile]="isMobile"
              [airlineCode]="flight.AirlineCode"
              [airlineName]="flight.AirlineName"
              [opAirlineCode]="flight.OpAirlineCode"
              [opAirlineName]="flight.OpAirlineName"
              [number]="flight.Number"
              [flightTimeInternal]="flight.FlightTimeInternal"
              [departureDate]="flight.DepartureDate"
              [departureAirport]="flight.DepartureAirport"
              [arrivalDate]="flight.ArrivalDate"
              [arrivalAirport]="flight.ArrivalAirport"
              [airplane]="flight.Equipment"
              [travelInfoProvider]="flightInfoProvider"
              [flightClass]="flightClass"
              [isLoadingFlightCabin]="isLoadingFlightCabin"
              [fareFamilies]="flight.FareFamilies"
              [cabin]="flight.Cabin">
              <app-luggage-tooltip
                luggageTooltip
                [handBaggage]="flight.HandBaggage"
                [fareFamily]="flight.FareFamilies"
                [fareBasis]="flight.FareBasis"
                [airline]="flight.AirlineCode"
                [baggage]="flight.BaggageRestrictions | luggage"
                [showShadow]="false"
                [showArrow]="false"
                [typeOfLuggage]="flight.BaggageRestrictions | typeLuggage"
                [departureDate]="flight.DepartureDate"
                [departureAirport]="flight.DepartureAirport"
                [arrivalAirport]="flight.ArrivalAirport"
                [isInternational]="isInternational">
              </app-luggage-tooltip>
            </app-travel-info>
            <app-flight-segment-connection
              [hasScales]="hasScales"
              [provider]="provider"
              [isConnectionInDifferentAirport]="flight.IsConnectionInDifferentAirport"
              [isScaleElement]="isScaleElement(sector, i)"
              [numberOfStops]="flight.NumberOfStops"
              [totalDuration]="sector.TotalDuration"
              [technicalStopAirport]="flight.TechnicalStopAirport"
              [technicalStopTime]="flight.TechnicalStopTime"
              [flight]="flightItem(sector, i)"
              [nextFlight]="nextFlightItem(sector, i)">
            </app-flight-segment-connection>
          </ng-container>
        </div>
      </ng-container>
    </div>
    <app-payment-detail
      *ngIf="isMobile"
      [passengerArrangement]="passengerArrangement"
      [price]="price"
      [isRappiProBrandig]="isRappiProBrandig$ | async"
      [conversionRate]="conversionRate"
      [productReference]="productReference">
    </app-payment-detail>
  </div>
</div>
